import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DatePickerComponent } from '@libs/ui-lib';
import { DateTime } from 'luxon';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'lib-health-history-date-picker',
  standalone: true,
  imports: [CommonModule, TranslateModule, DatePickerComponent, SvgIconComponent],
  templateUrl: './health-history-date-picker.component.html',
  styleUrls: ['./health-history-date-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: HealthHistoryDatePickerComponent,
    },
  ],
})
export class HealthHistoryDatePickerComponent implements ControlValueAccessor {
  public readonly labelTranslationKey = input.required<string>();
  public readonly minDate = input<DateTime>();
  public readonly maxDate = input<DateTime>();
  public readonly errorState = input<boolean>(false);
  public dateTimeNow = DateTime.now();

  protected selectedDate = signal<DateTime | null>(null);
  protected readonly touched = signal<boolean>(false);
  protected readonly disabled = signal<boolean>(false);

  private onChange = (value: DateTime | null) => {};
  private onTouched = () => {};

  public writeValue(value: DateTime | null): void {
    this.selectedDate.set(value);
  }

  public registerOnChange(onChange: (value: DateTime | null) => void): void {
    this.onChange = onChange;
  }
  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  public markAsTouched(): void {
    if (!this.touched()) {
      this.onTouched();
      this.touched.set(true);
    }
  }

  public setDisabledState(disabled: boolean): void {
    this.disabled.set(disabled);
  }

  public onDateSelect(date: DateTime | null): void {
    this.markAsTouched();

    if (!this.disabled()) {
      this.selectedDate.set(date);
      this.onChange(this.selectedDate());
    }
  }
}
